module.exports = __webpack_public_path__ + "static/img/restaurant-view-tabs03.1483a3e4.svg";